import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './XY.html?raw';
import on from 'dojo/on';
import topic from 'dojo/topic';
import ResourcePicker from '../../moreCore/UI/ResourcePicker/ResourcePicker';
import SelectEntityDialog from '../../moreCore/UI/SelectEntityDialog/SelectEntityDialog';
import "../../moreCore/UI/SelectEntityDialog/SelectEntityDialog";
import FloatingMenu from '../../moreCore/UI/Floating/Menu';
import ExpandableSection from '../../moreCore/UI/Container/ExpandableSection';

import Tooltip from '../../moreCore/UI/Floating/Tooltip';
import xyStatefulSection from './xyStatefulSection';

import ProgressBar from '../../moreCore/UI/ProgressBar/ProgressBar';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import "../../moreCore/UI/CheckBox/CheckBox";
import PageStack from '../../moreCore/UI/Tabbing/PageStack';
import "../../moreCore/UI/Tabbing/PageStack";
import MultiLangEdit from '../../moreCore/UI/MultiLangEdit/MultiLangEdit';
import "../../moreCore/UI/MultiLangEdit/MultiLangEdit";
import ColorPicker from '../../moreCore/UI/ColorPicker/ColorPicker';
import "../../moreCore/UI/ColorPicker/ColorPicker";
import Edit from '../../moreCore/UI/Edit/Edit';
import NumberInput from '../../moreCore/UI/NumberInput/NumberInput';

import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import Multiselect from '../../moreCore/UI/Multiselect/Multiselect';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import RadioGroup from '../../moreCore/UI/RadioGroup/RadioGroup';
import "../../moreCore/UI/RadioGroup/RadioGroup";
import "../../moreCore/UI/ClipboardTextBox/ClipboardTextBox";


import documentEditor from '../fileEditor/documentEditor/documentEditor';
import pdfEditor from '../fileEditor/pdfEditor/pdfEditor';
import { DateHelpers, FeatureHelpers } from "../../more/Helpers";
import MDSC_SignInThirdParty from '../MDS_Connect/ThirdParty/MDSC_SignInThirdParty';
import SpreadsheetTable from '../../moreCore/UI/Spreadsheet/SpreadsheetTable';
import HintBox from '../../moreCore/UI/HintBox/HintBox';

class XY extends compose(_WidgetBaseSP) {
    templateString: any = template;

    checkbox1: MdsLax<InstanceType<typeof CheckBox>>;
    content1: HTMLElement;
    content2: HTMLElement;
    content3: HTMLElement;
    tooltipContainer: HTMLElement;

    inputColor: MdsLax<InstanceType<typeof ColorPicker>>;
    colorpickerResultContainer: HTMLElement;

    inputSearchSelect: MdsLax<InstanceType<typeof SearchSelect>>;
    inputMultiselect: MdsLax<InstanceType<typeof Multiselect>>;
    txtMultiselectData: HTMLPreElement;

    inputHintbox1: MdsLax<InstanceType<typeof HintBox>>;


    sectionStatefulForm: HTMLElement;
    statefuleDirtyStatus: HTMLElement;

    statefulForm: MdsLax<InstanceType<typeof xyStatefulSection>>;

    progressBar: MdsLax<InstanceType<typeof ProgressBar>>;
    progressBarModal: MdsLax<InstanceType<typeof ProgressBar>>;
    sectionProgressBar: HTMLElement;

    pageStack: MdsLax<InstanceType<typeof PageStack>>;
    page1: HTMLElement;
    page2: HTMLElement;
    page3: HTMLElement;

    inputMultilang: MdsLax<InstanceType<typeof MultiLangEdit<any>>>;
    outputMultilangData: HTMLElement;
    inputMultilangData: HTMLTextAreaElement;
    inputMultilangAttribute: HTMLInputElement;

    inputHtml: MdsLax<InstanceType<typeof Edit>>;


    _onClick_CreateExpandable(): void {

        let expander1b = new ExpandableSection();
        expander1b.setup("einfach nur text", "verschachtelt", "small");
        expander1b.placeAt(this.content1);

        let expander1 = new ExpandableSection();
        expander1.setup(this.content1, "Content 1");

        let expander2 = new ExpandableSection();
        expander2.setup(this.content2, "Content 2", "small");

        let expander3 = new ExpandableSection();
        expander3.setup(this.content3, "Content 3", "large");


    }




    inputDate: HTMLInputElement;
    resourcePickerContainer: HTMLInputElement;
    outputContainer: HTMLInputElement;
    txtDateOutput: HTMLElement;

    resourcePicker: MdsLax<InstanceType<typeof ResourcePicker>>;

    selectEntityDlg22: MdsLax<InstanceType<typeof SelectEntityDialog<any>>>;

    today = new Date();

    //data: Array<DummyData> = []


    _onChange_InputMcDate(newValue: Date) {
        console.debug("date changed", newValue);

        this.txtDateOutput.innerHTML = DateHelpers.dateTimeToString(newValue);
    }
    _onChange_InputMcDateTime(newValue: { date: Date }) {
        console.debug("datetime changed", newValue.date);

        this.txtDateOutput.innerHTML = DateHelpers.dateTimeToString(newValue.date);
    }

    _onChange_InputDate(evt: Event) {
        console.debug("date changed", this.inputDate.value);

        this.loadTimeslots();
    }

    _onClick_Menu(evt: MouseEvent) {
        let menu = new FloatingMenu;

        menu.open(evt, [{
            label: "Eins",
            heading: "Abschnitt 1",
            callback: lang.hitch(this, this._menuCallback, "eins")
        },
        {
            label: "Zwei",
            heading: "Abschnitt 2",
            callback: lang.hitch(this, this._menuCallback, "zwei"),
            //icon: "fas fa-cubes"
        },
        {
            label: "Drei",
            heading: "Abschnitt 2",
            callback: lang.hitch(this, this._menuCallback, "drei"),
            //icon: "fas fa-cubes"
        }, {
            label: "Vier",
            /*heading: "Abschnitt 2",*/
            callback: lang.hitch(this, this._menuCallback, "vier"),
            //icon: "fas fa-cubes"
        }],

            "Das Menü")
    }

    private _menuCallback(result) {
        alert(result);
    }


    loadTimeslots() {
        // Dashboard + WidgetList from API

        let data = {
            "targetDate": this.inputDate.value,
            "carpoolID": "xxxxyyy"
        };

        //let url = window.appRoot + "XY/GetConfiguration";
        let url = window.appRoot + "XY/GetVehicleTimeslots";
        this.StandbyStart(this.resourcePickerContainer);
        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onLoadTimeSlotsResponse),
            lang.hitch(this, this._onLoadTimeslotsError),
            false // sync
        );
    }

    _onLoadTimeSlotsResponse(response) {
        this.UiModder.domConstruct.empty(this.resourcePickerContainer);
        console.log("_onLoadTimeSlotsResponse", response)
        this.resourcePicker = new ResourcePicker();
        this.resourcePicker.setConfiguration(response);
        this.resourcePicker.setBaseUnits(3, 1, null);
        this.resourcePicker.setLayout("35em");
        this.resourcePicker.placeAt(this.resourcePickerContainer);
        this.StandbyStop();

        on(this.resourcePicker, "change", lang.hitch(this, this._onChange_ResourcePicker));
    }

    _onChange_ResourcePicker(values: Array<string>) {
        let displayValues = this.resourcePicker.getValue(true);
        this.UiModder.domConstruct.empty(this.outputContainer);
        for (let value of values) {
            this.UiModder.domConstruct.create("div", { "innerHTML": value }, this.outputContainer);
        }
    }

    _onLoadTimeslotsError(error: more.requestErrorMessage) {
        this.StandbyStop();
        alert(error.Message);
    }

    _onClick_OpenSelectEntityDialog22(evt: MouseEvent) {
        this.selectEntityDlg22 = new SelectEntityDialog;
        let dlg = this.selectEntityDlg22;

        dlg.setup("Titel titel 22", lang.hitch(this, this._onCallback_Dlg), "XY/GetSelectEntityDialogData");

        dlg.addTree("default", "Standard", null, "Raum", "Sonderbarer Raum", null, false, null, null, null, { "test": "1234" }, { "currentData": "lalalala" });
        dlg.addTree("public", "mit Publikum", "Suche (Name)", "RaumEx", "", "fas fa-theater-masks", false, null, null, null, { "test": "zweiter baum publikum" }, { "currentData": "was Anderes" });
        dlg.addTree("test1", "Test1");
        //dlg.addTree("test2", "Test2");
        dlg.show();
    }



    _onClick_OpenDlgWithConfig1(evt: MouseEvent) {
        this._onClick_OpenDlgWithConfig(evt, 1);
    }

    _onClick_OpenDlgWithConfig2(evt: MouseEvent,) {
        this._onClick_OpenDlgWithConfig(evt, 2);
    }

    _onClick_OpenDlgWithConfig(evt: MouseEvent, mode: number = 0) {

        let btn = <HTMLButtonElement>(evt.target);

        let data = { "mode": mode };

        let url = window.appRoot + "XY/GetSEDconfig";
        this.StandbyStart(this.resourcePickerContainer);
        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onGetDlgConfig),
            lang.hitch(this, this._onGetDlgConfigError),
            false // sync
        );
    }

    previousSEDvalue: any;
    _onGetDlgConfig(data: any) {
        this.selectEntityDlg22 = new SelectEntityDialog;
        let dlg = this.selectEntityDlg22;
        dlg.setConfiguration(data, lang.hitch(this, this._onCallback_Dlg));
        dlg.setValues(this.previousSEDvalue);
        dlg.show();
    }
    _onGetDlgConfigError(error: more.requestErrorMessage) {
        alert(error.Message);
    }


    _onClick_OpenSelectEntityDialog21() {

    }

    _onCallback_Dlg(data, items) {
        console.log("selectentitydlg callback", data, items);
        this.previousSEDvalue = items;
    }

    _onClick_Progress0() {
        this.progressBar.setNewTarget(0);

        if (this.progressBarModal) this.progressBarModal.setNewTarget(0, "starte...");
    }
    _onClick_Progress10() {
        this.progressBar.setNewTarget(10);

        if (this.progressBarModal) this.progressBarModal.setNewTarget(10, "verarbeite...")
    }
    _onClick_Progress50() {
        this.progressBar.setNewTarget(50, "verarbeite...");

        if (this.progressBarModal) this.progressBarModal.setNewTarget(50, "verarbeite...")
    }
    _onClick_Progress80() {
        this.progressBar.setNewTarget(80);

        if (this.progressBarModal) this.progressBarModal.setNewTarget(80, "Finalisierung...");

    }
    _onClick_Progress95() {
        this.progressBar.setNewTarget(95, "fast fertig...");

        if (this.progressBarModal) this.progressBarModal.setNewTarget(95, "Aufräumen...");
    }
    _onClick_Progress100() {
        this.progressBar.setNewTarget(100, "fertig");

        if (this.progressBarModal) this.progressBarModal.setNewTarget(100, "Fertig");
    }
    _onClick_ProgressModal() {

        if (this.progressBarModal) {
            this.progressBarModal.destroy();
        }

        this.progressBarModal = new ProgressBar({
            textlinesCount: 3,
            displayType: "modal",
            heading: "Progressbar Modal",
            initialText: "wird gestartet"
        });

        //this.progressBarModal.placeAt(this.sectionProgressBar, "last");

        setTimeout(lang.hitch(this, this._onClick_Progress0), 100);
        setTimeout(lang.hitch(this, this._onClick_Progress10), 2000);
        setTimeout(lang.hitch(this, this._onClick_Progress50), 5000);
        setTimeout(lang.hitch(this, this._onClick_Progress80), 8000);
        setTimeout(lang.hitch(this, this._onClick_Progress95), 10000);
        setTimeout(lang.hitch(this, this._onClick_Progress100), 23000);
    }

    _onClick_ProgressBar_LiveCommand() {
        topic.publish("/LiveCommand/GlobalProgressBar/ShowModal", {
            heading: "Überschrift",
            text: "geht los",
            textlines: 3,
            closeOnCompletion: false
        });

        setTimeout(lang.hitch(this, topic.publish, "/LiveCommand/GlobalProgressBar/Update", {
            progress: 20,
            text: "40 prozent"
        }), 1000);


        setTimeout(lang.hitch(this, topic.publish, "/LiveCommand/GlobalProgressBar/Update", {
            progress: 40,
            text: "40 prozent"
        }), 1800);

        setTimeout(lang.hitch(this, topic.publish, "/LiveCommand/GlobalProgressBar/Update", {
            progress: 70,
            text: "80 prozent"
        }), 2000);

        setTimeout(lang.hitch(this, topic.publish, "/LiveCommand/GlobalProgressBar/Update", {
            progress: 80,
            text: "80 prozent"
        }), 2200);

        setTimeout(lang.hitch(this, topic.publish, "/LiveCommand/GlobalProgressBar/Update", {
            progress: 100,
            text: "80 prozent"
        }), 2400);

        //    setTimeout(lang.hitch(this, topic.publish, "/LiveCommand/GlobalProgressBar/Remove"), 35000);
    }

    _onClick_SetupPageStack() {
        this.pageStack.placeElementIntoPageStack(this.page1, { label: "page1", name: "page1", coloration: "#a08" });

        if (confirm("page2?") == true) {
            this.pageStack.placeElementIntoPageStack(this.page2, { label: "Page 2 - Die Fortsetzung der bekannten Geschichte", name: "page2", coloration: "#c81" });
        }

        if (confirm("page3?") == true) {
            this.pageStack.placeElementIntoPageStack(this.page3, { label: "Page 3 Abschluss", name: "page3" });
        }
    }

    _onClick_SetupStateful() {
        if (this.statefulSectionxy) {
            return;
        }
        this.setupStatefulForm();
    }

    _onClick_CreateStateful() {
        if (this.statefulSectionxy) {
            return;
        }
        this.setupStatefulForm(false);
    }

    private statefulSectionxy: MdsLax<InstanceType<typeof xyStatefulSection>> = null;
    _onClick_ResetStatefulDirty() {
        if (this.statefulSectionxy) {
            this.statefulSectionxy.resetDirty();
        }
    }
    setupStatefulForm(wData?: boolean) {
        let form = new xyStatefulSection();
        this.statefulSectionxy = form;
        form.placeAt(this.sectionStatefulForm);

        form.on("dirty", lang.hitch(this, this._onDirtyStatefulSection));

        if (wData !== false) {
            let dummyData = {
                ID: "xyz",
                Classname: "ev_booking",
                ref_ev_project: {
                    ID: "123",
                    ev_project_name: "Projektname 1"
                },
                ref_ev_booking_status: {
                    ID: "000000ff:00000015",
                    Classname: "ev_booking_status",
                    description: "Definitiv",
                },
                tickets_capacity: 30,
                note: "Testbuchung für Stateful",
                ev_booking_name: "Buchung Titel",
                cast: [{
                    ID: "abc",
                    c_cast_address: "Interpret 1",
                    c_cast_perfomer: "Schlagzeug"
                }]
            };


            form.setData(dummyData);
        }
    }
    _onDirtyStatefulSection(dirty: boolean) {
        this.UiModder.domClass.toggle(this.statefuleDirtyStatus, "w3-disabled w3-dark-gray", !dirty);
        this.UiModder.domClass.toggle(this.statefuleDirtyStatus, "warningBG", dirty);
    }

    _onChange_CB(value: any) {
        this.showToast({
            title: "Checkbox: " + (value != null ? value.toString() : "null"),
            iconClass: "fas fa-check-square",
            /*message: "blab bla",*/
            options: {
                ID: "XY-CB",
                timeout: 2000
            }
        });
    }

    _onClick_SetMultilangData() {
        let strData = this.inputMultilangData.value;

        try {
            let data = JSON.parse(strData);

            if (data) this.inputMultilang.setValue({ entity: data, targetAttribute: this.inputMultilangAttribute.value });
        } catch (ex) {
            this.inputMultilang.setValue(strData);
        }


    }

    _onClick_SetMultilangMultiline() {
        this.inputMultilang.setIsMultiline(!this.inputMultilang.isMultiline, 5);
    }
    _onClick_SetMultilangMandatory() {
        this.inputMultilang.setMandatory(!this.inputMultilang.isMandatory);
    }
    _onClick_SetMultilangMandatoryLang() {

        this.inputMultilang.setMandatoryLanguages(["D", "E"]);
    }

    _onChange_MultilangEdit() {
        this.UiModder.domAttr.set(this.outputMultilangData, "innerHTML", JSON.stringify(this.inputMultilang.getValue()));

    }

    _onChange_HtmlEdit() {

    }

    _onChange_HtmlMultilang() {

    }


    _onChange_Colorpicker() {
        let value = this.inputColor.getValue();

        let color: more.EntityAPIColor = value;
        let bg = this.inputColor.getBgColorHex();
        let txt = this.inputColor.getTxtColorHex();

        this.UiModder.domStyle.set(this.colorpickerResultContainer, "backgroundColor", bg);
        this.UiModder.domStyle.set(this.colorpickerResultContainer, "color", txt);

        console.log("_onChange_Colorpicker", color);
    }

    _onClick_SetupSelects1() {
        interface entry { key: string, label: string, group: string, color: string };

        let colors = ["#ff0000", "#ccbb00", "#aa00ff", "#1199aa"];
        let groups = ["Gruppe 1", "Gruppe 2", "Gruppe 3", "Gruppe 4"];
        let data: Array<entry> = [];

        for (let i = 0; i < 20; i++) {
            let colorIndex = Math.random() * colors.length;

            data.push({
                color: colors[Math.floor(colorIndex)],
                group: groups[Math.floor(colorIndex)],
                key: data.length.toString(),
                label: "Eintrag " + data.length.toString()
            });
        }

        this.inputMultiselect.setOptionHeadingGroupAttribute("group");
        this.inputMultiselect.setData(null, data, null, "label", "key", "color");

        this.inputSearchSelect.setOptionHeadingGroupAttribute("group");
        this.inputSearchSelect.setData(null, data, null, "label", "key", "color");
    }
    _onClick_SetupSelects2() {
        interface entry { key: string, label: string, group: { label: string, value: string, color?: string, icon?: string }, color: string };

        let colors = ["#ff0000", "#ccbb00", "#aa00ff", "#1199aa"];
        let groups = ["Gruppe 1", "Gruppe 2", "Gruppe 3", "Gruppe 4"];
        let groupValues = ["d", "b", "a", "c"];
        let groupColors = ["#1111ff", "#440044", "#aaa", "ffcc00"];
        let data: Array<entry> = [];

        for (let i = 0; i < 20; i++) {
            let colorIndex = Math.random() * colors.length;
            let groupIndex = Math.floor(Math.random() * groupValues.length);
            data.push({
                color: colors[Math.floor(colorIndex)],
                group: {
                    value: groupValues[groupIndex],
                    label: groups[groupIndex],
                    color: groupColors[groupIndex]
                },
                key: data.length.toString(),
                label: "Eintrag " + data.length.toString()
            });
        }

        this.txtMultiselectData.innerHTML = JSON.stringify(data);

        this.inputMultiselect.setData(null, data, null, "label", "key", "color", "group.label", "group.value", "group.color");
        this.inputMultiselect.setGroupIcons(["b"], ["fas fa-user"]);

        this.inputSearchSelect.setData(null, data, null, "label", "key", "color", "group.label", "group.value", "group.color");
        this.inputSearchSelect.setGroupIcons(["a", "b"], ["fas fa-user", "fas fa-users"]);
    }

    _onClick_SetupSelects3() {
        interface entry { key: string, label: string, group: { label: string, value: string, color?: string, icon?: string }, color: string };

        let singleEntry: entry = {
            key: "x",
            label: "einziger Eintrag",
            color: null,
            group: null
        };

        let unknownEntry: entry = {
            key: "UNKNOWNVALUE",
            label: "unbekannter Eintrag",
            color: null,
            group: null
        };

        this.inputMultiselect.autosetSingleValue("strict");
        this.inputMultiselect.setData(unknownEntry, [singleEntry], false, "label", "key");

        this.inputSearchSelect.autosetSingleValue("strict");
        this.inputSearchSelect.setData(null, [singleEntry], false, "label", "key");

    }

    _onClick_GenericDlgVar1() {
        let dlg = new GenericDialog();
        dlg.show("dlg mit ja-nein und normalem callback",
            "Var 1",
            null,
            null,
            "yesno",
            lang.hitch(this, this._dlgCallbackDefault));
    }
    _onClick_GenericDlgVar2() {
        let dlg = new GenericDialog();
        dlg.show("dlg mit ja-nein-cancel und getrenntem callback",
            "Var 2",
            null,
            null,
            "yesnocancel",
            [lang.hitch(this, this._dlgCallbackDefault), lang.hitch(this, this._dlgCallbackCancelNo)]);
    }
    _onClick_GenericDlgVar3() {
        let dlg = new GenericDialog();
        dlg.show("dlg mit submit-cancel und getrenntem callback",
            "Var 3",
            null,
            null,
            "submitcancel",
            lang.hitch(this, this._dlgCallbackDefault),
        );

        dlg.addButton("custom",
            "custom button",
            lang.hitch(this, this._dlgCallbackCustom),
            null,
            null,
            "fas fa-carrot",
            true);

        dlg.keepOpen = true;

        dlg.setDistinctiveCallbacksMode(true);
    }

    _onClick_LoadDocumentFromServer(ev: MouseEvent) {
        (ev.target as HTMLButtonElement).disabled = true;
        this.docEditorContainer.style.display = "unset";
        let conf = window.confirm("Load sample document (yes) or load by base64 string (no)?");
        if (conf){
            this.docEditor.loadDocumentByKey("000001b5:0001fea1");
        }else{
            let basedSixtyFour = window.prompt("document base64 content")
            let filetype = window.prompt("file type (.rtf, .docx, ...)");
            this.docEditor.loadDocumentByBase64(basedSixtyFour, filetype);
        }
    }

    _onClick_LoadPdfFromServer(ev: MouseEvent) {
        (ev.target as HTMLButtonElement).disabled = true;
        this.pdfEditorContainer.style.display = "unset";
        //this.pdfEditor.show({ key: "000001b5:0001febb" }, false);
        fetch(window.appRoot + "Content/syncfusion/pdfReader/testfile.pdf")
            .then(res => res.blob())
            .then(blob => {
                return new Promise<string>((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        const base64data = reader.result as string;
                        resolve(base64data);
                    };
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                });
            })
            .then(base64String => {
                this.pdfEditor.loadBase64(base64String, null); //error can't save entity, weil keine id
            });
    }

    _dlgCallbackCustom(result: any) {
        alert("callback custom");
        console.info("_dlgCallbackCustom", result);
    }
    _dlgCallbackDefault(result: any) {
        alert("callback default");
        console.info("_dlgCallbackDefault", result);
    }
    _dlgCallbackCancelNo(result: any) {
        alert("callback cancelNo");
        console.info("_dlgCallbackCancelNo", result);
    }


    radioInput: MdsLax<InstanceType<typeof RadioGroup>>;

    docEditorContainer: HTMLDivElement;
    private docEditor: MdsLax<InstanceType<typeof documentEditor>>;
    pdfEditorContainer: HTMLDivElement;
    private pdfEditor: MdsLax<InstanceType<typeof pdfEditor>>;
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.inputHintbox1.setLabel("Hintbox Label");

        this.docEditor = new documentEditor();
        this.docEditor.placeAt(this.docEditorContainer);
        this.docEditorContainer.style.display = "none";

        this.pdfEditor = new pdfEditor();
        this.pdfEditor.placeAt(this.pdfEditorContainer);
        this.pdfEditorContainer.style.display = "none";

        let xyend:HTMLDivElement = this.domNode.querySelector("#endOfXY");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.inputDate.value = "2022-07-07";
        //this._onChange_InputDate(null);

        this.setTitles("DEV Playground", "DEV Playground");

        let tooltip = new Tooltip();
        tooltip.setup({
            content: "Inhalt des Tooltip",
            delayMS: 1000,
            followMouse: true,
            targetnode: this.tooltipContainer,
            heading: "überschrift",
            icon: "fas fa-calendar",
            subtitle: "Viel text drunter, blablabla<br>Keine Lust auf noch merh Text"

        });

        this.progressBar = new ProgressBar({
            initialText: "noch nicht gestartet"
        });
        this.progressBar.placeAt(this.sectionProgressBar, "last");

    }

    private async _onClick_mdsc_sampleAppNewTab(ev:Event){
        let signInPromt = new MDSC_SignInThirdParty();
        await signInPromt.SignInUser(
            'dev___showBasicData',
            {targetInteraction:'newTab'},
            {
                beforeJumpOff: () => { console.log("beforeJumpOff"); return true; },
                beforeStart: () => { console.log("beforeStart"); return true; },
                onError: () => { console.log("onError"); },
                onIframeReady: () => { console.log("oniframeReady"); },
                onOperationFinished: () => { console.log("onOperationFinished"); },
                onPopupReady: () => { console.log("onPopupReady"); },
                onPermissionDeniedByUser: () => { console.log("onPopupReady"); }
            },
            true
        );
    }
    private async _onClick_mdsc_sampleAppIFrame(ev: Event) {
        let signInPromt = new MDSC_SignInThirdParty();
        await signInPromt.SignInUser(
            'dev___showBasicData',
            {
                targetInteraction: 'iFrame',
                iframeConfig: {
                    targetContainer: document.getElementById('mdsc_demo_iframe'),
                    iframeSize: { width: '500px', height: '300px' },
                    title: 'iFrame App'
                }
            },
            {
                beforeJumpOff: () => { console.log("beforeJumpOff"); return true; },
                beforeStart: () => { console.log("beforeStart"); return true; },
                onError: () => { console.log("onError"); },
                onIframeReady: () => { console.log("oniframeReady"); },
                onOperationFinished: () => { console.log("onOperationFinished"); },
                onPopupReady: () => { console.log("onPopupReady"); }
            }
        );
    }
    private async _onClick_mdsc_sampleAppPopup(ev: Event) {
        let signInPromt = new MDSC_SignInThirdParty();
        await signInPromt.SignInUser(
            'dev___showBasicData',
            {
                targetInteraction: 'popup',
                popupConfig: {
                    popupTitle: 'Popup App',
                    popupSize: { width: 600, height: 400 }
                }
            },
            {
                beforeJumpOff: () => { console.log("beforeJumpOff"); return true; },
                beforeStart: () => { console.log("beforeStart"); return true; },
                onError: () => { console.log("onError"); },
                onIframeReady: () => { console.log("oniframeReady"); },
                onOperationFinished: () => { console.log("onOperationFinished"); },
                onPopupReady: () => { console.log("onPopupReady"); }
            }
        );
    }

    private async _onClick_mdsc_sampleAppSameTab(ev: Event) {
        let signInPromt = new MDSC_SignInThirdParty();
        await signInPromt.SignInUser(
            'dev___showBasicData',
            { targetInteraction: 'redirectSameTab' },
            {
                beforeJumpOff: () => { console.log("beforeJumpOff"); return true; },
                beforeStart: () => { console.log("beforeStart"); return true; },
                onError: () => { console.log("onError"); },
                onIframeReady: () => { console.log("oniframeReady"); },
                onOperationFinished: () => { console.log("onOperationFinished"); },
                onPopupReady: () => { console.log("onPopupReady"); }
            }
        );
    }

    private _onClick_throwExceptionForDiagnosticTesting(){
        console.log("throwing an example exception to test diagnostics...");
        throw new Error("This is an example exception!");
    }


    /** SPREADHSHEETTABLE */

    private sectionSpreadsheet: HTMLElement;
    private spreadSheetContainer: HTMLElement;
    private inputSpreadSheetRowTitle: HTMLInputElement;
    spreadsheet: MdsLax<InstanceType<typeof SpreadsheetTable>>;

    private _onClick_SetupSpreadsheet1GE() {
        this._onClick_SetupSpreadsheet1(true);
    }
    private _onClick_SetupSpreadsheet1(globalEdit?: boolean) {
        this.hideNode(this.sectionSpreadsheet, false);

        this.spreadsheet = new SpreadsheetTable();
        //this.spreadsheet.placeAt(this.spreadSheetContainer, "only");


        let data: Array<{ ID: string, ref_cost_type: { ID: string, label: string }, is_bool: boolean, count?: number, intvalue?: number, intvalue2?: number, percent: number, cost: number, notes?: string, calcValue?: number, }> = [
            {
                ID: "D1",
                cost: 299,
                notes: "keine",
                percent: 1,
                count: 17.12666,
                intvalue: 16,
                intvalue2: 32,
                is_bool: true,
                ref_cost_type: { ID: "C1", label: "Werbung" },
                calcValue: 555,

            },
            {
                ID: "D2",
                cost: 380,
                intvalue: 10,
                percent: 0.80,
                is_bool: true,
                ref_cost_type: { ID: "C2", label: "Miete" }

            }
        ];

        let columns: Array<SpreadsheetTableTypes.ColumnDescriptor> = [

            {
                columnID: "1cost",
                valueAttribute: "cost",
                valueType: "currency",
                heading: "Kosten Cost",
                editable: true,
                summaryDescriptors: [{
                    heading: "Summe Kosten",
                    mode: "sum"
                }]

            },
            {
                columnID: "2pct",
                valueAttribute: "percent",
                collapsible: true,
                infoText: "collapsible",
                valueType: "percent",
                heading: "Prozente",
                editable: true,

            },

            {
                columnID: "4int",
                valueAttribute: "intvalue",
                valueType: "int",
                heading: "int1",
                unitLabel: "Stk",
                editable: true,
                summaryDescriptors: [{
                    heading: "Summe Stück",
                    mode: "sum"
                },
                    //{
                    //heading: "",
                    //mode: "function",
                    //summaryFunction: lang.hitch(this, this._spreadSheetValueCellCalcSum)
                    //}
                ]
            },
            {
                columnID: "3bool",
                valueAttribute: "is_bool",
                valueType: "bool",
                heading: "Stk verdoppeln?",
                infoText: "Ja-Nein-Feld",
                editable: true,
            },
            {
                valueAttribute: "intvalue2",
                columnID: "7calcAsync",
                valueType: "int",
                heading: "Stk effektiv",
                infoText: "Ja: Verdoppelt 4int, Nein: 4int",
                editable: false,
                formula: {
                    triggeringColumns: [{ columnID: "4int" }, { columnID: "3bool" }],
                    calcFunction: "asyncQueue"
                }
            },
            {
                columnID: "5float",
                valueAttribute: "count",
                valueType: "float",
                places: 3,
                infoText: "float mit 3 Nachkommas",
                heading: "Basiswert",
                editable: true,
            },
            //{
            //    columnID: "6float",
            //    valueAttribute: "count",
            //    valueType: "float",
            //    formatterFct: lang.hitch(this, this._spreadSheetFormatterFloat2),
            //    heading: "float2",
            //    editable: true,
            //},

            {
                columnID: "7floatCalcX",
                valueType: "float",
                heading: "X% von 'Basiswert'",
                editable: false,
                valueAttribute: "calcValue",
                formula: {
                    triggeringColumns: [{ columnID: "5float" }, { columnID: "2pct" }],
                    calcFunction: lang.hitch(this, this._spreadSheetValueCellCalc)
                },
                summaryDescriptors: [{
                    mode: "sum",
                    heading: ""
                }]
            }
        ]

        this.spreadsheet.show("node", this.spreadSheetContainer);

        this.spreadsheet.setup({
            rowIdAttribute: "ID",
            columns: columns,
            rowLabelAttribute: "ref_cost_type.label",
            title: "Kosten Kosten!",
            asyncCellCalculationFct: lang.hitch(this, this._spreadsheetCalcAsync),
            permanentEditingMode: globalEdit === true
        }, data);



    }

    private _spreadsheetCalcAsync(data: SpreadsheetTableTypes.AsyncCellCalculationRequest): boolean {
        setTimeout(lang.hitch(this, this._spreadsheetCalcAsyncResponse, data), 2000);

        return true;
    }

    private _spreadsheetCalcAsyncResponse(data: SpreadsheetTableTypes.AsyncCellCalculationRequest) {

        let response: Array<SpreadsheetTableTypes.AsyncCellCalculationResponse> = [];

        for (let cell of data.pendingCells) {

            let stkCell = this.spreadsheet.getCell(cell.rowID, "4int");
            let yesnoCell = this.spreadsheet.getCell(cell.rowID, "3bool");
            let value = stkCell.value as number;
            switch (yesnoCell.value) {
                case true:
                    value = value * 2;
                    break;
            }

            response.push({
                cellID: cell.cellID,
                value: value
            });
        }


        this.spreadsheet.setCalculationQueueResults(data.transactionID, response);
    }

    private _spreadSheetFormatterFloat2(value: number, cell: SpreadsheetTableTypes.TableCell): string {
        let dsp = value?.toFixed(4) + " - custom formatter";
        return dsp;

    }

    private _spreadSheetValueCellCalc(sourceValue: any, sourceCell: SpreadsheetTableTypes.TableCell, targetCell: SpreadsheetTableTypes.DataCell): SpreadsheetTableTypes.cellValueCalcResult {


        let result: number = 0;
        switch (targetCell.column.columnID) {
            case "7floatCalc50":
                result = sourceValue * 0.5;
                break;
            case "7floatCalc30":
                result = sourceValue * 0.3;
                break;
            case "7floatCalcX":
                let pctCell = this.spreadsheet.getCell(targetCell.row, "2pct");
                let pct = pctCell.value as number;
                let valueCell = this.spreadsheet.getCell(targetCell.row, "5float");
                let floatVal = valueCell.value as number;

                result = floatVal * pct;

                if (floatVal == null || floatVal == undefined) {
                    result = undefined;
                }
                break;
        }

        let response: SpreadsheetTableTypes.cellValueCalcResult = {
            value: result,
            invalidateCell: result < 10 || !result
        };

        return response;

    }
    private _spreadSheetValueCellCalcSum(cells: Array<SpreadsheetTableTypes.DataCell>): string {

        let result = "";
        let sum = 0;
        for (let cell of cells) {
            if (typeof cell.value == "number") {
                sum += cell.value;
            }
        }

        result = sum + " (";

        return result;
    }


    private _onClick_AddRowToSpreadsheet() {

        this.spreadsheet.addRow({ intvalue: Math.random() * 100, percent: Math.random(), ref_cost_type: { label: this.inputSpreadSheetRowTitle.value } })
    }

    private numberInput1: MdsLax<InstanceType<typeof NumberInput>>;
    private _onClick_SetNumberInput1Value1(evt) {
        this.numberInput1.setShowCalculator(true);
        this.numberInput1.setValue(Math.random() * 10000 + 9);
    }

    private _onClick_SetupSpreadsheetDK() {
    //    let spreadsheet = new SpreadsheetTable();
    //    spreadsheet.setup({
    //        columns: [{
    //            columnID: "100%",
    //            editable: true,
    //            heading: "100%",
    //            valueType: "currency"
    //        }],
    //        rowIdAttribute: "ref_cost_type.ID",
    //        rowLabelAttribute: "ref_cost_type.description",
    //        enableGlobalEditingMode: true
    //    });

    //    spreadsheet.show("fullScreenDlg", "DK Calculation");

    //    spreadsheet.addButtonEx({
    //        internalName: "loadData",
    //        callback: lang.hitch(this, this._loadSpreadsheetData),
    //        label: "Daten laden",
    //        iconClass: "fas fa-download"
    //    });

    //    this.spreadsheet = spreadsheet;
    }


    private async _onClick_mdsc_evisio(ev: Event) {
        if (this.getCurrentUserName() != "sm" && this.getCurrentUserName() != "s.mayer@moredms.com"){
            alert("WIP, bitte nicht entfernen danke!");
            return;
        }
        let signInPromt = new MDSC_SignInThirdParty();
        await signInPromt.SignInUser(
            'evisio_v2',
            {
                targetInteraction: 'popup',
                popupConfig: {
                    popupTitle: 'Popup App',
                    popupSize: { width: 800, height: 1000 }
                }
            },
            {
                beforeJumpOff: () => { console.log("beforeJumpOff"); return true; },
                beforeStart: () => { console.log("beforeStart"); return true; },
                onError: () => { console.log("onError"); },
                onIframeReady: () => { console.log("oniframeReady"); },
                onOperationFinished: () => { console.log("onOperationFinished"); },
                onPopupReady: () => { console.log("onPopupReady"); }
            },
            false
        );
    }


}

export default mdsWidget(XY);
